import React from "react";

const Subcribtion = () => {
  return (
    <div className="subcrib-sec flex flex-col">
      <div className="wrapWidth wrap flex flex-col">
        <div className="mail-sec flex">
          <div className="mail-left flex aic">
            <img src="./images/EmailIcon.svg" className="img" />
            <div className="lbl">
              Suscríbete a nuestra
              <br /> comunidad
            </div>
          </div>
          <div className="mail-center flex-col">
            <input
              type="text"
              className="txt cleanbtn"
              placeholder="Escriba tu email"
            />
            <div className="search-desc flex aic">
              <div className="dot"></div>
              <div className="desc">
                He leido y acepto la poítica de protección de datos.
              </div>
            </div>
          </div>
          <div className="mail-right flex  jc">
            <div className="btn button">Enviar</div>
          </div>
        </div>
        <div className="options-wrap">
          <div className="card flex aic jc">
            <img src="./images/seleccion-2.svg" className="card-img" />
            <div className="card-lbl">
              Artistas y obras
              <br /> seleccionados
            </div>
          </div>
          <div className="card flex aic jc">
            <img src="./images/soporte-tecnico-2.svg" className="card-img" />
            <div className="card-lbl">
              Soporte
              <br /> 24/7/365
            </div>
          </div>
          <div className="card flex aic jc">
            <img src="./images/prohibido.svg" className="card-img" />
            <div className="card-lbl">
              Sin replicas
              <br /> de NFTs
            </div>
          </div>
          <div className="card flex aic jc">
            <img src="./images/pago-seguro-2.svg" className="card-img" />
            <div className="card-lbl">
              Pagos
              <br /> Seguros
            </div>
          </div>
        </div>
      </div>
      <div className="artist-sec flex">
        <div className="wrapWidth wrap flex">
          <div className="left flex flex-col items-start jc">
            <div className="flex aic jc flex-col">
              <div className="tag ">
                ¿Eres artista? <br />
                <span> Nos encargamos de todo. </span>
              </div>
              <div className="actions flex aic jc">
                <div className="btn button">APLICAR</div>
              </div>
            </div>
          </div>
          <div className="right flex">
            <div className="artist-wrap">
              <div className="artist-card flex aic">
                <img src="./images/consejo.svg" className="artist-icon" />
                <div className="artist-lbl">
                  Asesoramiento
                  <br />
                  integral
                </div>
              </div>
              <div className="artist-card flex aic">
                <img
                  src="./images/contratos-inteligentes.svg"
                  className="artist-icon"
                />
                <div className="artist-lbl">
                  Creación de
                  <br />
                  Smart Contract
                </div>
              </div>
              <div className="artist-card flex aic">
                <img src="./images/subir.svg" className="artist-icon" />
                <div className="artist-lbl">
                  Asesoramiento
                  <br />
                  integral
                </div>
              </div>
              <div className="artist-card flex aic">
                <img
                  src="./images/metodo-de-pago.svg"
                  className="artist-icon"
                />
                <div className="artist-lbl">
                  Creación de
                  <br />
                  Smart Contract
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subcribtion;
